import "temporal-polyfill/global";

import { createRoot } from "react-dom/client";

import { Root } from "@/views/Root";

const container = document.getElementById("app");
if (!container) {
  throw new Error("Missing root container 'app'");
}

const root = createRoot(container);
root.render(<Root />);
